/**
 * 内容市场课程首页
 * @author Kody
 * @date 2021/04
 * @url /market
 */
import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './app';
import { bizServices } from 'businessCommon';
const { Page } = bizServices;
import { getAppData } from './service/marketHomeService';
import { IMarketHomePageData } from './interface/pageData';
import { MarketHeader } from 'market/@marketCommon/components/marketHeader/marketHeader';

import 'common/src/styles/common.scss';
import 'businessCommon/src/styles/text.scss';
import 'businessCommon/src/styles/icon.import/iconfont.scss';
import 'market/@marketCommon/style/layout.scss';
import 'market/@marketCommon/style/base.scss';
import './marketHome.scss';

class MarketHome extends Page<IMarketHomePageData> {
    constructor() {
        super(getAppData());
        this.initialLog();
        // this.setupPageTitle(this.getPageTitle());
        this.render();
    }
    public getInitState() {
        const data = getAppData() || {};
        const state = {
            pageData: {
                contextInfo: data.contextInfo || {},
                userInfo: data.userInfo || {},
            },
        };
        return state;
    }
    public initialLog() {
        // todo
    }
    public render() {
        const store = this.getInitState();
        const pageData = store.pageData;
        const lang = getAppData('Lang');
        const userInfo = pageData.userInfo;
        const system = getAppData('SYSTEM');
        const siteHost = getAppData('siteHost');

        ReactDOM.render(
            <div className="market-twww-layout">
                <MarketHeader lang={lang} system={system} userInfo={userInfo} siteHost={siteHost} />
                <App initState={{ ...pageData }}></App>
            </div>,
            document.querySelector('.doc-wide'),
        );
    }
    // private getPageTitle() {
    //   // todo
    // }
}

export default new MarketHome();
